<div class="warranty">
  <customer-select class="customer-selector" style="display: flex; justify-content: end; background: white;
    border-bottom: 1px solid black;"></customer-select>
  <!-- ============ Header: title + date range + last update time ============ -->
  <div class="warranty-header">
    <h2 class="warranty-title">质保申请总览</h2>
    <div class="warranty-header-right">
      <span class="warranty-update-time">数据更新时间: {{ lastUpdateTime }}</span>
      <nz-range-picker class="warranty-date-picker" nzMode="month" [nzAllowClear]="false" [nzDisabledDate]="disabledMonth"
        [(ngModel)]="dateRange" (nzOnCalendarChange)="onCalendarChange($event)" (nzOnOpenChange)="onOpenChange($event)"
        (ngModelChange)="onDateRangeChange()"></nz-range-picker>
    </div>
  </div>

  <!-- ============ Summary cards ============ -->
  <div class="summary-cards">
    <div class="summary-card" *ngFor="let card of summaryCards" [style.background-color]="card.bgColor">
      <div class="summary-card-label">{{ card.label }}</div>
      <div class="summary-card-value">{{ card.value }}</div>
    </div>
  </div>

  <!-- ============ Main content: chart card + news aside ============ -->
  <div class="warranty-content">
    <div class="warranty-main">
      <!-- 月度索赔总览 -->
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-title">月度索赔总览</h3>
        </div>

        <div class="chart-wrapper">
          <div class="chart-y-label-left">数量（个）</div>
          <div class="chart-bars" #monthlyChart></div>
          <div class="chart-y-label-right">金额（元）</div>
        </div>
      </div>
    </div>

    <!-- ============ Aside: 信息速递 ============ -->
    <div class="warranty-aside">
      <div class="aside-header">
        <div class="aside-title">
          <i nz-icon nzType="notification" nzTheme="outline"></i>
          <span>信息速递</span>
        </div>
      </div>

      <div class="news-card">
        <div class="news-item" *ngFor="let news of newsList; let last = last" [class.no-border]="last">
          <div class="news-item-top">
            <span class="news-date">{{ news.date }}</span>
            <!-- <span class="news-tag" [style.color]="news.tagColor" [style.background-color]="news.tagBg">
              {{ news.tag }}
            </span> -->
          </div>
          <div class="news-title">{{ news.title }}</div>
          <div class="news-desc">{{ news.desc }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ Full-width panels ============ -->
  <div class="warranty-full-width">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-title">索赔金额和比例分析</h3>
        </div>
        <div class="table-wrapper category-table-wrapper">
          <table class="warranty-table">
            <colgroup>
              <col style="width: 180px;">
              <col style="width: 150px;">
              <col style="width: 220px;">
              <col style="width: 120px;">
              <col style="width: 160px;">
              <col style="width: 150px;">
            </colgroup>
            <thead>
              <tr>
                <th>产品大类</th>
                <th>质保索赔数量</th>
                <th>质保索赔总价(不含税)</th>
                <th>采购数量</th>
                <th>采购总额(不含税)</th>
                <th>实际金额占比</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="categoryAnalysis.length === 0">
                <td colspan="6" style="text-align: center; padding: 40px 0; color: #999;">无数据</td>
              </tr>
              <tr *ngFor="let row of pagedCategoryAnalysis">
                <td>{{ row.category }}</td>
                <td>{{ row.claimQty }}</td>
                <td>{{ row.claimAmount }}</td>
                <td>{{ row.purchaseQty }}</td>
                <td>{{ row.purchaseAmount }}</td>
                <td>{{ row.amountRatio }}</td>
              </tr>
            </tbody>
          </table>

          <div class="table-pagination">
            <span class="pagination-total">共{{ categoryPagination.total }}条</span>
            <nz-pagination class="warranty-pagination" [nzPageIndex]="categoryPagination.pageIndex"
              [nzPageSize]="categoryPagination.pageSize" [nzTotal]="categoryPagination.total"
              (nzPageIndexChange)="categoryPageIndexChange($event)"></nz-pagination>
          </div>
        </div>
      </div>

      <!-- 质保申请明细 -->
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-title">质保申请明细</h3>
        </div>

        <!-- 明细查询条件 -->
        <div class="detail-filter">
          <div class="filter-field">
            <input class="filter-input" nz-input placeholder="质保单号" [(ngModel)]="detailFilter.claimNo" />
          </div>

          <div class="filter-field">
            <input class="filter-input" nz-input placeholder="料号" [(ngModel)]="detailFilter.boschMaterialNo" />
          </div>

          <div class="filter-actions">
            <button class="btn btn-outline" (click)="handleDetailSearch()">
              <i nz-icon nzType="search" nzTheme="outline"></i>
              <span>搜索</span>
            </button>
            <button class="btn btn-outline" (click)="handleDetailClear()">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
              <span>清除</span>
            </button>
          </div>
        </div>

        <div class="table-wrapper detail-table-wrapper">
          <table class="warranty-table">
            <colgroup>
              <col style="width: 100px;">
              <col style="width: 140px;">
              <col style="width: 100px;">
              <col style="width: 140px;">
              <col style="width: 160px;">
              <col style="width: 180px;">
              <col style="width: 180px;">
              <col style="width: 132px;">
            </colgroup>
            <thead>
              <tr>
                <th>质保单号</th>
                <th>系统提交日期</th>
                <th>申请数量</th>
                <th>博世物料编号</th>
                <th>索赔金额(不含税)</th>
                <th>备注1</th>
                <th>备注2</th>
                <th>状态</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="warrantyDetails.length === 0">
                <td colspan="8" style="text-align: center; padding: 40px 0; color: #999;">无数据</td>
              </tr>
              <tr *ngFor="let row of pagedWarrantyDetails">
                <td>{{ row.claimNumber }}</td>
                <td>{{ row.submitDate }}</td>
                <td>{{ row.qty }}</td>
                <td>{{ row.materialNumber }}</td>
                <td>{{ row.claimAmount }}</td>
                <td class="remark-cell" [title]="row.remark1">{{ row.remark1 }}</td>
                <td class="remark-cell" [title]="row.remark2">{{ row.remark2 }}</td>
                <td>
                  <span class="status-chip" [style.color]="getStatusColor(row.statusName).color"
                    [style.background-color]="getStatusColor(row.statusName).bg">
                    {{ row.statusName }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <div class="table-pagination">
            <span class="pagination-total">共{{ pagination.total }}条</span>
            <nz-pagination class="warranty-pagination" [nzPageIndex]="pagination.pageIndex"
              [nzPageSize]="pagination.pageSize" [nzTotal]="pagination.total"
              (nzPageIndexChange)="pageIndexChange($event)"></nz-pagination>
          </div>
        </div>
      </div>
  </div>
</div>
